import { css } from "@emotion/react";
import { theme } from "styles/theme";

const FooterSideBarStyle = {
  wrapper: css`
    width: 295px;
    background-color: ${theme.colors.orange[100]};
  `,

  linkItem: css`
    background-color: ${theme.colors.orange[100]};
    cursor: pointer;

    display: flex;
    align-items: center;

    color: white;
    padding: 15px 0 15px 10px;
    text-decoration: none;
    transition: 0.3s;
    &.active {
      background-color: ${theme.colors.gradient[50]};
    }
    &:hover {
      background-color: ${theme.colors.orange[200]};
      transition: 0.3s;
    }
  `,
};

export default FooterSideBarStyle;
